import React, { Component } from "react";
import _ from "lodash";

import ProBadge from "../../../react/components/ProBadge";
import { UpgradePlanDialogType } from "../../../react/views/MarketingDialogs/UpgradePlanDialog";
import WorkspaceController from "../../../controllers/WorkspaceController";
import { ActionPermissionsObject } from "../../../../common/interfaces/index";
import { MenuItem } from "../../../Components/Menu";
import { Icon } from "../../../Components/Icon";

// import NavigationController from "./NavigationController";
import { SlideActionsController } from "./SlideActionsController";
import { PopupContent } from "../../../Components/Popup";
import { NestedMenu, NestedMenuItem } from "../../../react/components/NestedMenuItem";

export class SlideActionsPopupMenu extends Component {
    duplicateSlides = async () => {
        const { selectedSlides, closePopup } = this.props;
        await SlideActionsController.duplicateSlides(selectedSlides);

        closePopup();
    }

    deleteSlides = () => {
        const { selectedSlides, closePopup } = this.props;
        // NavigationController.deleteSlides();
        SlideActionsController.deleteSlides(selectedSlides);
        closePopup();
    }

    skipSlide = () => {
        const { selectedSlides, closePopup } = this.props;
        SlideActionsController.skipSlide(selectedSlides, true);
        closePopup();
    }

    unSkipSlide = () => {
        const { selectedSlides, closePopup } = this.props;
        SlideActionsController.skipSlide(selectedSlides, false);
        closePopup();
    }

    exportSlideToJpeg = () => {
        const { closePopup, selectedSlides } = this.props;
        selectedSlides[0].exportSlideToJpeg();
        closePopup();
    }

    exportSlideToPPT = async () => {
        const { closePopup, selectedSlides } = this.props;
        await SlideActionsController.exportSlideToPPT(selectedSlides[0].id);
        closePopup();
    }

    handleCutSlides = e => {
        const { selectedSlides, closePopup } = this.props;
        e.preventDefault();
        SlideActionsController.cutSlides(selectedSlides);
        closePopup();
    }

    handlePasteSlides = e => {
        const { selectedSlides, closePopup } = this.props;
        e.preventDefault();
        SlideActionsController.pasteSlides(selectedSlides);
        closePopup();
    }

    handleCopySlides = e => {
        const { selectedSlides, closePopup } = this.props;
        e.preventDefault();
        SlideActionsController.copySlides(selectedSlides);
        closePopup();
    }

    render() {
        const { selectedSlides, presentation } = this.props;

        if (selectedSlides.length === 0) return null;

        // Calculate count based on selected slides or default to 1 (the passed slide)
        // const count = selectedSlides && selectedSlides.size > 0 ? selectedSlides.size : 1;
        const count = selectedSlides.length;

        const isSkippedSlide = presentation.isSlideSkipped(selectedSlides[0]);

        return (
            <PopupContent>
                <MenuItem onClick={this.duplicateSlides} divider>
                    <Icon>content_copy</Icon>
                    {count !== 1 ? `Duplicate ${count} Slides` : "Duplicate Slide"}
                </MenuItem>
                <MenuItem onClick={this.deleteSlides} divider>
                    <Icon>delete</Icon>
                    {count !== 1 ? `Delete ${count} Slides` : "Delete Slide"}
                </MenuItem>
                {isSkippedSlide && (
                    <MenuItem onClick={this.unSkipSlide} divider>
                        <Icon>visibility_off</Icon>
                        {count !== 1 ? `Unskip ${count} Slides` : "Unskip Slide"}
                    </MenuItem>
                )}
                {!isSkippedSlide && (
                    <MenuItem onClick={this.skipSlide} divider>
                        <Icon>visibility</Icon>
                        {count !== 1 ? `Skip ${count} Slides` : "Skip Slide"}
                    </MenuItem>
                )}
                <MenuItem onClick={this.handleCopySlides}>
                    <Icon>content_copy</Icon>
                    {count !== 1 ? `Copy ${count} Slides` : "Copy Slide"}
                </MenuItem>
                <MenuItem onClick={this.handleCutSlides}>
                    <Icon>content_cut</Icon>
                    {count !== 1 ? `Cut ${count} Slides` : "Cut Slide"}
                </MenuItem>
                <MenuItem onClick={this.handlePasteSlides} divider>
                    <Icon>content_paste</Icon>
                    {count !== 1 ? `Paste ${count} Slides` : "Paste Slide"}
                </MenuItem>
                {count === 1 && (
                    <NestedMenuItem label="Export" icon={<Icon>cloud_download</Icon>}>
                        <MenuItem onClick={this.exportSlideToJpeg}>
                            <Icon>panorama</Icon>
                            Export Slide To JPEG
                        </MenuItem>
                        <MenuItem onClick={this.exportSlideToPPT}>
                            <Icon>cloud_download</Icon>
                            Export Slide To PPTX
                            <ProBadge
                                show={WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.EXPORT_PRESENTATION_TO_EDITABLE, "use")}
                                upgradeType={UpgradePlanDialogType.UPGRADE_PLAN}
                                analytics={{
                                    cta: {
                                        cta: "exportToPPT",
                                        ...presentation.getAnalytics()
                                    }
                                }}
                                workspaceId={presentation.getWorkspaceId()}
                            />
                        </MenuItem>
                    </NestedMenuItem>
                )}
            </PopupContent>
        );
    }
}
